import PropTypes from 'prop-types'

import { getContentfulField } from '../../utils/GatsbyUtils'

import Image from './Image'


const PortfolioProject = data => (data && data.slug ? {
  slug: data.slug,
  title: data.title,
  subTitle: data.subTitle,
  domain: getContentfulField(data, 'domain'),
  thumbnail: Image(data.thumbnail),
  isOnDisplay: data.isOnDisplay,
} : null)

PortfolioProject.propTypes = PropTypes.shape({
  slug: PropTypes.string.isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  domain: PropTypes.string.isRequired,
  thumbnail: Image.propTypes.isRequired,
  isOnDisplay: PropTypes.Boolean,
})

PortfolioProject.defaultProps = {
  title: '',
  subTitle: '',
  isOnDisplay: false,
}

export default PortfolioProject
